import React from "react";
import { Input } from "reactstrap";
import { DEVELOPMENT_TOPICS } from "../shared/developmentTopics";

/**
 * Dropdown ให้เลือกหัวข้อการพัฒนา (ใช้แทนของเดิมที่ก็อปวางซ้ำ 3 จุด)
 *
 * props:
 * - placeholderValue: ค่า value ของ option แรก (EvaluateForm ไม่ใส่ value -> undefined,
 *   EditEvaluateForm ใส่ value="0") ต้องส่งให้ตรงกับพฤติกรรมเดิมของแต่ละจุดที่เรียกใช้
 * - defaultValue: ใช้กับกรณี uncontrolled select ที่ต้องตั้งค่าเริ่มต้น (defaultValue={item.development_type_id})
 * - onChange: handler เดิมของแต่ละจุดเรียกใช้ (ส่ง e.target.value กลับไปเหมือนเดิม)
 */
function DevelopmentTopicSelect({ placeholderValue, defaultValue, onChange }) {
  return (
    <Input type="select" defaultValue={defaultValue} onChange={onChange}>
      {placeholderValue === undefined ? (
        <option>เลือกหัวข้อการพัฒนา</option>
      ) : (
        <option value={placeholderValue}>เลือกหัวข้อการพัฒนา</option>
      )}
      {DEVELOPMENT_TOPICS.map(topic => (
        <option key={topic.value} value={topic.value}>
          {topic.label}
        </option>
      ))}
    </Input>
  );
}

export default DevelopmentTopicSelect;
